
import { Component, Vue } from 'vue-property-decorator'
import { getAimSummary, getAimDaily, getAimTopCanes } from '@/api/aimAnalytics'

@Component({ name: 'AimAnalytics' })
export default class extends Vue {
  private summary: any = { ozet: null, aylik: [] }
  private daily: any[] = []
  private topCanes: any[] = []

  private summaryLoading = false
  private dailyLoading = false
  private topLoading = false

  private days = 30
  private topLimit = 20

  created() {
    this.loadSummary()
    this.loadDaily()
    this.loadTop()
  }

  private fmt(v: any): string {
    const n = Number(v)
    return Number.isFinite(n) ? n.toLocaleString('tr-TR') : '0'
  }

  private async loadSummary() {
    this.summaryLoading = true
    try {
      const res = await getAimSummary()
      this.summary = res.data?.data || { ozet: null, aylik: [] }
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('aimAnalytics.loadSummaryFailed') as string)
    } finally {
      this.summaryLoading = false
    }
  }

  private async loadDaily() {
    this.dailyLoading = true
    try {
      const res = await getAimDaily(this.days)
      this.daily = res.data?.data?.gunluk || []
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('aimAnalytics.loadDailyFailed') as string)
    } finally {
      this.dailyLoading = false
    }
  }

  private async loadTop() {
    this.topLoading = true
    try {
      const res = await getAimTopCanes(this.topLimit)
      this.topCanes = res.data?.data?.bastonlar || []
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('aimAnalytics.loadCanesFailed') as string)
    } finally {
      this.topLoading = false
    }
  }
}
